// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Ko-z","badgeLink":"Lo-z","category":"Mo-z"};